// src/lib/utils.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}
var getPropByString = (obj, propString) => {
  if (!propString) return obj;
  let _obj = obj;
  let prop;
  const props = propString.split(".");
  const iLen = props.length - 1;
  let i = 0;
  for (i = 0; i < iLen; i++) {
    prop = props[i];
    const candidate = _obj[prop];
    if (candidate !== void 0) {
      _obj = candidate;
    } else {
      break;
    }
  }
  return _obj[props[i]];
};

export {
  cn,
  getPropByString
};
